import { useState } from 'react';
import clsx from 'clsx';
import { Transition } from '@headlessui/react';
import useInterval from '@/hooks/useInterval';
import usePageVisibility from '@/hooks/usePageVisibility';
import Container from '@/components/Container';
import Image from '@/components/Image';
import WorldMap from './WorldMap';

function TestimonialItem({ picture, name, certification, position, active }) {
  return (
    <div className={clsx('absolute z-20', position)}>
      <Transition
        show={active}
        enter="transition duration-1000 transform"
        enterFrom="opacity-0 translate-y-10 scale-90"
        enterTo="opacity-100 translate-y-0 scale-100"
        leave="transition duration-700 transform"
        leaveFrom="opacity-100 translate-y-0 scale-100"
        leaveTo="opacity-0 translate-y-10 scale-90"
      >
        <div className="bg-white rounded-lg shadow-xl flex items-center space-x-2 pl-3 pr-6 py-4">
          <div className="w-12 h-12 rounded-full bg-gray-200">
            <Image
              className="w-12 h-12 rounded-full"
              alt={`Imagen de ${name}`}
              src={picture}
            />
          </div>
          <div className="flex flex-col">
            <h4 className="font-semibold text-sm">{name}</h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              {certification}
            </p>
          </div>
        </div>
      </Transition>
    </div>
  );
}

export default function WorldMapCertifications() {
  const [active, setActive] = useState(0);

  const isPageVisible = usePageVisibility();

  useInterval(() => {
    if (isPageVisible) {
      let nextIndex = active + 1;
      if (nextIndex > 5) {
        nextIndex = 0;
      }
      setActive(nextIndex);
    }
  }, 10000);

  return (
    <div className="w-full relative z-0 lg:pb-20 overflow-hidden">
      <Container className="relative z-20">
        <div className="relative h-30 w-full xl:pt-20 xl:pb-40">
          <TestimonialItem
            name="Noe Villagómez Alva"
            certification="Official Scrum Master Certification"
            picture="https://i.pravatar.cc/150?u=a042581f4e29026704d"
            position="left-0 bottom-0"
            active={active === 0}
          />
          <TestimonialItem
            name="Huberto Salazar Almanza"
            certification="Official Scrum Developer Certification"
            picture="https://i.pravatar.cc/150?u=a042581f4a29026704d"
            position="right-0 bottom-0"
            active={active === 1}
          />
          <TestimonialItem
            name="Andy Jaime Quintanilla"
            certification="Official Scrum Developer Certification"
            picture="https://i.pravatar.cc/150?u=a04258pf4a29026704d"
            position="top-0 left-1/2 transform -translate-x-1/2"
            active={active === 2}
          />
          <TestimonialItem
            name="Tirso Herrera Almanza"
            certification="Official Scrum Master Certification"
            picture="https://i.pravatar.cc/150?u=a142581f4a29026704d"
            position="left-0 top-0 ml-24 mt-10"
            active={active === 3}
          />
          <TestimonialItem
            name="Jeannette Figueroa Saldana"
            certification="Official Agile Coach Certification"
            picture="https://i.pravatar.cc/150?u=x192581f4a29026704d"
            position="right-0 top-0 mr-24 mt-10"
            active={active === 4}
          />
          <TestimonialItem
            name="Mirella Pagan Morales"
            certification="Official Agile Coach Certification"
            picture="https://i.pravatar.cc/150?u=x192583f4989026704d"
            position="right-0 top-0 mr-60 mt-10"
            active={active === 5}
          />
        </div>
      </Container>
      <WorldMap />
    </div>
  );
}
